/**
 * Componente de protección de rutas por permisos
 * Verifica que el usuario tenga al menos uno de los roles requeridos
 * o ejecuta una función de verificación personalizada
 */
import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Box, Alert, CircularProgress } from "@mui/material";
import AuthService from "../../services/auth.service";
import Toasts from "../notificacion/Toasts";
import { StateContext } from "../context/StateProvider";

export default function RequierePermisos({
    children,
    rolesRequeridos = [],
    verificacionPersonalizada = null,
    redirigirA = null,
    mostrarToast = false,
    mensajeError = "No tienes permisos para acceder a esta sección.",
}) {
    const navigate = useNavigate();
    const { state, updateState } = useContext(StateContext);
    const [tienePermiso, setTienePermiso] = useState(null);
    const [verificando, setVerificando] = useState(true);

    useEffect(() => {
        let tieneAcceso;

        // Si se proporciona verificación personalizada, usarla
        if (verificacionPersonalizada && typeof verificacionPersonalizada === 'function') {
            tieneAcceso = verificacionPersonalizada();
        } else {
            // Verificación por roles estándar
            const roles = AuthService.getUserRoles();
            tieneAcceso = rolesRequeridos.length === 0 ||
                         rolesRequeridos.some(role => roles.includes(role));
        }

        setTienePermiso(tieneAcceso);
        setVerificando(false);

        if (!tieneAcceso) {
            // Mostrar toast si está habilitado
            if (mostrarToast) {
                updateState({
                    toasts: [...state.toasts, Toasts.generateToast(mensajeError, "error")],
                });
            }

            // Redirigir si se especificó ruta
            if (redirigirA) {
                navigate(redirigirA);
            }
        }
    }, [rolesRequeridos, verificacionPersonalizada, redirigirA, mostrarToast, mensajeError, navigate, state, updateState]);

    // Mostrar loader mientras verifica
    if (verificando) {
        return (
            <Box sx={{ p: 3, display: "flex", justifyContent: "center", alignItems: "center", minHeight: 400 }}>
                <CircularProgress />
            </Box>
        );
    }

    // Mostrar error si no tiene permisos (y no hay redirección)
    if (tienePermiso === false && !redirigirA) {
        return (
            <Box sx={{ p: 3 }}>
                <Alert severity="error">
                    {mensajeError}
                </Alert>
            </Box>
        );
    }

    // Renderizar contenido si tiene permisos
    if (tienePermiso === true) {
        return <>{children}</>;
    }

    // Si no tiene permisos y hay redirección, no renderizar nada (se está redirigiendo)
    return null;
}
